module.exports = __webpack_public_path__ + "img/inst_default_avatar.cebdc323.png";